<template>
 <div>
    <el-dialog :title="title" :visible.sync="visible" :before-close="close" width="75%">
        <lot-operate-list v-model="tableData" :show-fields="showFields"></lot-operate-list>
        <div class="marginTop">
            <!-- <el-button type="primary" @click="close">确定</el-button> -->
        </div>
    </el-dialog>
 </div>
</template>

<script>
import lotOperateList from 'cps/lab-order/lot-operate-list'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    showFields: {
      type: Array,
      default: () => []
    }
  },
  components: {
    lotOperateList
  },
  watch: {
    dialogVisible (val) {
      this.visible = val
    }
  },
  data () {
    return {
      visible: this.dialogVisible,
      title: '已勾选数据'
    }
  },
  methods: {
    close () {
      this.$emit('updateVisible', false)
    }
  }
}
</script>

<style lang="less">

</style>
